import { OAuthService } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomOAuthService extends OAuthService {
  public async createLoginUrl(
    state?: string,
    loginHint?: string,
    customRedirectUri?: string,
    noPrompt?: boolean,
    params?: Record<string, any>
  ): Promise<string> {
    return super.createLoginUrl(state, loginHint, customRedirectUri, noPrompt, params);
  }
}
